import * as React from 'react';
import {Route, Switch} from 'react-router-dom';
import {History} from 'history';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';
import Search from './search';
import Pages from './pages';
import {PUBLIC_PATH, EMBED_PATH} from '../constants';
import About from './about';
import Contact from './contact';
import Terms from './terms';
import Privacy from './privacy';
import ReactGA from 'react-ga';

export default (props: {history: History}) => {
    React.useEffect(() => {
        ReactGA.initialize(
            [
                {
                    trackingId: 'UA',
                    gaOptions: {
                        name: 'harmonize',
                    },
                },
                //   {
                //    trackingId: 'UA-163581263-1',
                //    gaOptions: { name: 'client' }
                //   }
            ],
            {debug: true, alwaysSendToDefaultTracker: false}
        );
    }, []);
    return (
        <React.Fragment>
            <Route path={PUBLIC_PATH}>
                <NavBar />
            </Route>
            <Switch>
                <Route
                    path={`${PUBLIC_PATH}/about`}
                    component={({history}: {history: History}) => <About history={history} />}
                />
                <Route
                    path={`${PUBLIC_PATH}/contact`}
                    component={({history}: {history: History}) => <Contact history={history} />}
                />
                <Route
                    path={`${PUBLIC_PATH}/terms`}
                    component={({history}: {history: History}) => <Terms history={history} />}
                />
                <Route
                    path={`${PUBLIC_PATH}/privacy`}
                    component={({history}: {history: History}) => <Privacy history={history} />}
                />
                <Route
                    path={[
                        `${PUBLIC_PATH}/:databaseName/:accountName/search`,
                        `${EMBED_PATH}/:databaseName/:accountName/search`,
                    ]}
                    exact={false}
                    component={Search}
                />
                <Route
                    path={[
                        `${PUBLIC_PATH}/pages/:pageName/:accountName`,
                        `${EMBED_PATH}/pages/:pageName/:accountName`,
                    ]}
                    component={({history, match}: {history: History; match: any}) => (
                        <Pages history={history} match={match} />
                    )}
                />
            </Switch>
            <Route path={PUBLIC_PATH}>
                <Footer history={props.history} />
            </Route>
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/public/index.tsx